import React from 'react';
class Graph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    
    // renderLines(){
    //     return Array(10).fill(null).map((el, i) => (
    //         <Line
    //             left = {i * 10}
    //             key = {i}
    //         />
    //     ))
    // }

    render(){
        const Line = ({left}) => {
            return (
                <div className="line"
                    style= {{ left: `${left}%` }}
                />
            )
        }
        return(
            <div className="graph-wrapper">
                <div className="graph">
                    <Line left={0} />
                    <Line left={20} />
                    <Line left={40} />
                    <Line left={60} />
                    <Line left={80} />
                </div>
            </div>
        )
    }
}
export {Graph}